export default __webpack_public_path__ + "static/media/note-alt.844fd8f8.svg";